export default {
  methods: {
    /**
     * Permet de ne récupérer que les bons filtres et options de la query string.
     * @returns {Array} Filtre et options voulues.
     */
    filterQuery() {
      /**
       * Gestion des filtres dans la queryString
       */
      const query = this.$route.query;
      const keys = Object.keys(query);

      /**
       * On récupère les filtres qui existent uniquement
       */
      const validFilters = keys
        .map((key) => {
          const toFindFilters = this.sideFilters && this.sideFilters.length ? this.sideFilters : this.filters || [];
          const filter = toFindFilters.find((_filter) => _filter.slug === key);
          return filter || null;
        })
        .filter((value) => value);

      /**
       * Pour chaque filtre on ne garde que ses bonnes options (celles qui existent)
       */
      const finalFilters = validFilters.map((_filter) => {
        /**
         * Options de ce filtre dans la queryString
         */
        const queryFilter = String(query[_filter.slug]);
        const queryOptions = queryFilter.split(",");
        const validOptions = queryOptions
          .filter((option) => _filter.options
            .find(({ id }) => option === String(id)))
          .map((option) => Number(option));

        return { ..._filter, options: validOptions };
      }).filter((filter) => filter.options.length > 0);

      return finalFilters;
    },
  },
};
